import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <path d="M9.66667 6V7.86667H15.8173L5 18.684L6.316 20L17.1333 9.18267V15.3333H19V6H9.66667Z" fill="currentColor" />
);

const Icon = createSvgIcon(svg, 'Outgoing');

export default Icon;
